module.exports = __webpack_public_path__ + "static/step3-41a61ee2f85e304a0008771c87a33389.png";